import { useState, useEffect, useRef } from "react";
import SideMenu from "../../features/sideMenu/SideMenu";
import { useParams } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import Usuarios from "../../assets/img/svg/usuario.svg";
import {
  fetchInstallerDocumentsType,
  fetchInstallerImage,
  uploadInstallerMedia,
  updateMediaExpiration,
  fetchInstallerById,
  deleteInstallerDocument,
} from "../functions/Functions";
import "./documentsInstallers.css";
import "./DocumentsInstaller.responsive.css";
import { Oval } from "react-loader-spinner";
import { Document, Page, pdfjs } from "react-pdf";
import useConfirmDialog from "../../features/modal/ConfirmDialog";
import No from "../../assets/img/svg/documents/no.svg";
import EditarIcon from "../../assets/img/svg/documents/editar.svg";
import CheckIcon from "../../assets/img/svg/documents/si.svg";
import Placeholder from "../../assets/img/svg/documents/placeholder.svg";
import DescargaAzul from "../../assets/img/svg/users/descargar.svg";
import DescargaVerde from "../../assets/img/svg/users/descargarGreen.svg";
import Subir from "../../assets/img/svg/providers/CargarVerde.svg";
import AExpirarIcon from "../../assets/img/svg/documents/aexp.svg";
import Expirado from "../../assets/img/svg/documents/exp.svg";
import { itemsProviders } from "../../constants/providers";
import Eliminar from "../../assets/img/svg/documents/eliminar.svg";
import Visible from "../../assets/img/svg/providers/ver.svg";
import SelectFile from "../../assets/img/svg/providers/selectFile.svg";
import PhotoWhiteBgGate from "../documentsValidator/photoValidator";
import DocumentQualityGate from "../documentsValidator/documentQualityGate";
import MenuIcon from "../../assets/img/svg/users/opciones.svg";
import CustomButton from "../../ui/button/Button";

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.mjs",
  import.meta.url,
).toString();

const puedeModificarDocumentos = (user) => {
  /* 
  ANGULAR:
  <!-- ngIf: contactoInstalador.habilitado && 
  (usuarioLogin.perfil.esAdministrador ||
  usuarioLogin.perfil.esLiderCuadrilla || 
  usuarioLogin.perfil.esLiderSeguridad ||
  usuarioLogin.perfil.esSupervisorCuadrillas || 
  usuarioLogin.perfil.esProjectManager ||
  usuarioLogin.perfil.esPersonalSolar || 
  usuarioLogin.perfil.esJefeInformacion) -->
  */
  return (
    user?.perfil?.esAdministrador ||
    user?.perfil?.esLiderCuadrilla ||
    user?.perfil?.esLiderSeguridad ||
    user?.perfil?.esSupervisorCuadrillas ||
    user?.perfil?.esProjectManager ||
    user?.perfil?.esPersonalSolar ||
    user?.perfil?.esJefeInformacion
  );
};

const DOC_GATE_BY_TYPE = {
  INE: {
    docOptions: {
      minBlurScore: 650,
      maxBorderPct: 12,
      maxClippedHiPct: 6,
      maxClippedLoPct: 14,
    },
  },
  IMSS: { docOptions: { minBlurScore: 600 } },
  DC3: { docOptions: { minBlurScore: 650 } },
  OTHER: { docOptions: { minBlurScore: 600, maxBorderPct: 20 } },
};

const DocumentsInstaller = ({ API_URL, user }) => {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [documentsType, setDocumentsType] = useState([]);
  const [images, setImages] = useState({});
  const fileInputRefs = useRef({});
  const [installer, setInstaller] = useState({});
  const [requiredDocuments, setRequiredDocuments] = useState([]);
  const [renderKey, setRenderKey] = useState(0);
  const [uploading, setUploading] = useState(false);
  const confirmDialog = useConfirmDialog();
  const [modalContent, setModalContent] = useState({ url: "", extension: "" });
  const [showModal, setShowModal] = useState(false);
  const [documentDates, setDocumentDates] = useState({});
  const [numPages, setNumPages] = useState(null);
  const [processedDownload, setProcessedDownload] = useState(null);
  // Archivo pendiente por tipo (cuando NO hay documento aún)
  const [pendingByType, setPendingByType] = useState({}); // { [lenguaje]: File }
  const [openMenuId, setOpenMenuId] = useState(null);
  const menuRef = useRef(null);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const installerResponse = await fetchInstallerById(API_URL, id);
      setInstaller(installerResponse);

      if (
        installerResponse.perfilInstalador &&
        installerResponse.perfilInstalador.documentosNecesarios
      ) {
        setRequiredDocuments(
          installerResponse.perfilInstalador.documentosNecesarios.split(","),
        );
      }

      const documentsResponse = await fetchInstallerDocumentsType(API_URL);
      setDocumentsType(documentsResponse);

      const newImages = {};
      for (const [i, document] of documentsResponse.entries()) {
        try {
          const response = await fetchInstallerImage(
            API_URL,
            document.lenguaje,
            id,
            "pdf",
          );
          const blob = response;
          const mimeType = blob.type;
          const extension = mimeType === "application/pdf" ? "pdf" : "image";

          const imageBlob = await fetchInstallerImage(
            API_URL,
            document.lenguaje,
            id,
            extension,
          );
          const imageObjectURL = URL.createObjectURL(imageBlob);
          newImages[document.lenguaje] = {
            url: imageObjectURL,
            extension,
            imageBlob,
          };
          if (extension === "pdf") {
            setRenderKey((prev) => prev + 1);
          }
        } catch (error) {
          console.error(
            `Error cargando la imagen para ${document.lenguaje}:`,
            error,
          );
        }
      }
      setImages(newImages);
    } catch (error) {
      console.error(
        "Error al cargar los datos del instalador y documentos:",
        error,
      );
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [API_URL, id]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpenMenuId(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const modalObjectUrl = useRef(null);

  const openPreviewModal = (blobOrUrl, extension) => {
    if (modalObjectUrl.current) {
      URL.revokeObjectURL(modalObjectUrl.current);
      modalObjectUrl.current = null;
    }

    // Verificamos si es un Blob o ya es una URL
    let newUrl;
    if (blobOrUrl instanceof Blob) {
      newUrl = URL.createObjectURL(blobOrUrl);
      modalObjectUrl.current = newUrl;
    } else {
      newUrl = blobOrUrl;
    }

    setModalContent({ url: newUrl, extension });
    setShowModal(true);
  };

  const closeModal = () => {
    if (modalObjectUrl.current) {
      URL.revokeObjectURL(modalObjectUrl.current);
      modalObjectUrl.current = null;
    }
    setShowModal(false);
  };

  // Mapeo de nombres de documentos a tipoMultimediaContacto esperado por el backend
  const tipoMultimediaMapping = {
    INE: "INE",
    IMSS: "IMSS",
    DC3: "DC3",
    CREDENCIAL: "CREDENTIAL",
    CERTIFICADO_MEDICO: "MEDICAL_CERTIFICATE",
    OTRO: "OTHER",
    FOTO: "PHOTO",
  };

  const handleFileUpload = async (event, documentType) => {
    setUploading(true);
    const file = event.target.files[0];
    if (!file) return;

    try {
      // si pasa de 5MB
      if (file.size > 5 * 1024 * 1024) {
        throw new Error(
          "El archivo supera 5MB. Por favor, sube uno más ligero.",
        );
      }

      const backendDocumentType =
        tipoMultimediaMapping[documentType] || documentType;

      const { status, success } = await uploadInstallerMedia(
        API_URL,
        installer.id,
        documentType,
        file,
      );

      if (success) {
        // Determinar la extensión directamente desde el tipo MIME del archivo subido
        //const extension = file.type === "application/pdf" ? "pdf" : "image";
        const extension =
          documentType === "FOTO" || documentType === "PHOTO"
            ? "image"
            : file.type === "application/pdf"
              ? "pdf"
              : "image";

        await new Promise((resolve) => setTimeout(resolve, 500)); // Evitar caché

        const fileBlob = await fetchInstallerImage(
          API_URL,
          backendDocumentType,
          installer.id,
          extension,
        );

        const newBlobURL = URL.createObjectURL(fileBlob);

        setImages((prevImages) => {
          const newImages = { ...prevImages };

          newImages[backendDocumentType] = {
            url: newBlobURL,
            extension,
            blob: fileBlob, // Guarda el blob aquí
          };
          return newImages;
        });

        // Forzar la renderización del componente
        setRenderKey((prev) => prev + 1);
      } else {
        console.error(`❌ Error en la subida. Código: ${status}`);
      }
    } catch (error) {
      console.error(
        `❌ Error al subir el archivo para ${documentType}:`,
        error,
      );
      confirmDialog({
        html: `Error al realizar la carga de ${documentType}. <br> Vuelva a repetir la operación con un archivo menor a 5MB.`,
        icon: "warning",
        iconHtml: `<img src="${Usuarios}" width="50" height="50" />`,
        confirmButtonText: "OK",
        mostrarCancelar: false,
        onConfirm: async () => {
          setUploading(false);
        },
      });
    } finally {
      setUploading(false);
      await fetchData();
    }
  };

  const handleButtonClick = (documentType) => {
    if (fileInputRefs.current[documentType]) {
      fileInputRefs.current[documentType].click();
    }
  };

  const downloadFile = (url, nombre = "documento") => {
    if (!url) return;
    const a = document.createElement("a");
    a.href = url;
    a.download = nombre; // sugerencia de nombre
    document.body.appendChild(a);
    a.click();
    a.remove();
  };

  const parseDateFromBackend = (dateValue) => {
    if (!dateValue) return null;

    // Si es un número (timestamp en milisegundos), lo convertimos a `Date`
    if (!isNaN(dateValue) && dateValue.toString().length > 10) {
      return new Date(Number(dateValue));
    }

    // Si es una cadena en formato `dd/MM/yyyy HH:mm:ss`, invertir día y mes
    const parts = dateValue.split(" ");
    if (parts.length === 2) {
      const [day, month, year] = parts[0].split("/");
      return new Date(`${year}-${day}-${month}T00:00:00`); // Invertimos mes y día
    }

    return new Date(dateValue);
  };

  const updateDate = async (isoDate, documentType) => {
    const date = new Date(isoDate);

    // Invertimos el día y el mes antes de enviarlo
    const formattedDate = `${String(date.getMonth() + 1).padStart(
      2,
      "0",
    )}/${String(date.getDate()).padStart(
      2,
      "0",
    )}/${date.getFullYear()} ${String(date.getHours()).padStart(
      2,
      "0",
    )}:${String(date.getMinutes()).padStart(2, "0")}:${String(
      date.getSeconds(),
    ).padStart(2, "0")}`;

    try {
      await updateMediaExpiration(
        API_URL,
        installer.id,
        documentType.toUpperCase(),
        formattedDate,
      );

      // Convertimos la fecha a timestamp para actualizar correctamente en el frontend
      const timestamp = date.getTime();

      setInstaller((prevInstaller) => ({
        ...prevInstaller,
        [`fechaVencimiento${
          documentType.charAt(0).toUpperCase() +
          documentType.slice(1).toLowerCase()
        }`]: timestamp, // Guardamos como timestamp para evitar errores de interpretación
      }));
    } catch (error) {
      console.error("Error actualizando la fecha en el frontend:", error);
    }
  };

  const formatName = (fullName) => {
    const lowercaseWords = ["de", "del", "la", "y"];
    return fullName
      .toLowerCase()
      .split(" ")
      .map((word) =>
        lowercaseWords.includes(word)
          ? word
          : word.charAt(0).toUpperCase() + word.slice(1),
      )
      .join(" ");
  };
  // Nombre de archivo coherente por tipo/extensión
  const fileNameFor = (docType, ext) => {
    const safeName = `${(installer?.nombre || "").trim()}_${(
      installer?.apellidos || ""
    ).trim()}`
      .replace(/\s+/g, "_")
      .replace(/[^\w\-\.]/g, "");
    return `${safeName || "instalador"}_${docType}.${ext}`;
  };

  // Disparar descarga (una por archivo)
  const triggerDownload = (blobOrUrl, name) => {
    const a = document.createElement("a");
    const href =
      blobOrUrl instanceof Blob ? URL.createObjectURL(blobOrUrl) : blobOrUrl;
    a.href = href;
    a.download = name;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    if (blobOrUrl instanceof Blob) URL.revokeObjectURL(href);
  };

  // Recolecta blobs disponibles (solo los que existan)
  const collectAllDocs = async () => {
    const entries = [];
    for (const doc of documentsType) {
      const f = images[doc.lenguaje];
      if (!f || !f.url) continue;

      const ext = f.extension === "pdf" ? "pdf" : "jpg";

      // intenta usar blob ya guardado; si no, haz fetch
      let blob = f.blob || f.imageBlob;
      if (!blob) {
        try {
          const r = await fetch(f.url);
          if (r.ok) blob = await r.blob();
        } catch (_) {
          blob = null;
        }
      }
      if (!blob) continue;

      entries.push({ filename: fileNameFor(doc.lenguaje, ext), blob });
    }
    return entries;
  };

  // Descarga todos, uno por uno (con pequeño delay para evitar bloqueos)
  const downloadAllIndividually = async () => {
    try {
      const entries = await collectAllDocs();
      if (!entries.length) {
        confirmDialog({
          html: "No hay documentos disponibles para descargar.",
          icon: "warning",
          iconHtml: `<img src="${Usuarios}" width="50" height="50" />`,
          confirmButtonText: "OK",
          mostrarCancelar: false,
        });
        return;
      }

      for (const { filename, blob } of entries) {
        triggerDownload(blob, filename);
        await new Promise((res) => setTimeout(res, 150));
      }
    } catch (err) {
      console.error("Error en descargas individuales:", err);
      confirmDialog({
        html: "Ocurrió un error al preparar las descargas.",
        icon: "warning",
        iconHtml: `<img src="${Usuarios}" width="50" height="50" />`,
        confirmButtonText: "OK",
        mostrarCancelar: false,
      });
    }
  };

  const Tooltip = ({ text }) => (
    <div className="tooltip-container">
      <span className="tooltip-icon">?</span>
      <div className="tooltip-box">{text}</div>
    </div>
  );

  const documentsInstaller = () => (
    <>
      <div
        style={{
          display: uploading ? "block" : "none",
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 9999,
        }}
      >
        <Oval
          visible={true}
          height="80"
          width="80"
          color="#4fa94d"
          ariaLabel="oval-loading"
          wrapperStyle={{}}
          wrapperClass=""
        />
      </div>
      <div className="page-header">
        <p className="document-name">
          Documento instalador:{" "}
          {formatName(`${installer.nombre} ${installer.apellidos}`)}
        </p>
        <CustomButton
          onClick={downloadAllIndividually}
          text="Exportar todo"
          background="#223D51"
          color="#FFFFFF"
          fontWeight={700}
          fontSize="14px"
          width="172px"
          height="38px"
          border={0}
          icon={true}
          src={DescargaVerde}
          iconW="12px"
          iconM="6px"
          gap="5px"
          hoverShadow="0 2px 6px rgba(0,0,0,0.18)"
          disabled={isLoading}
        />
      </div>

      <div className="documents-container">
        <div className="documents-header-row">
          <div className="doc-status">Estatus</div> {/* Estado */}
          <div className="doc-name">Documento</div> {/* Nombre */}
          <div className="doc-date">Fecha de vencimiento</div>
          <div className="doc-upt">Actualizar documento</div>
          <div className="doc-sha">Acciones</div> {/* Subir/Eliminar */}
        </div>
        {documentsType.map((document, index) => {
          const fileData = images[document.lenguaje] || {};
          const fileUrl = fileData.url || Placeholder;
          let fileExtension = null;
          let dateFile = null;
          let isRequired = null;
          let documentClass = "document-gray";
          const today = new Date();
          const twoMonthsLater = new Date();
          twoMonthsLater.setMonth(today.getMonth() + 2); // Fecha 2 meses después de hoy

          if (document.lenguaje === "PHOTO") {
            isRequired = requiredDocuments.includes("FOTO");
            fileExtension = installer[`extensionFoto`];
          } else if (document.lenguaje === "INE") {
            isRequired = requiredDocuments.includes("INE");
            fileExtension = installer[`extensionIne`];
            dateFile = installer[`fechaVencimientoIne`];
          } else if (document.lenguaje === "IMSS") {
            isRequired = requiredDocuments.includes("IMSS");
            dateFile = installer[`fechaVencimientoImss`];
            fileExtension = installer[`extensionImss`];
          } else if (document.lenguaje === "MEDICAL_CERTIFICATE") {
            isRequired = requiredDocuments.includes("CERTIFICADO_MEDICO");
            fileExtension = installer[`extensionCertificado`];
            dateFile = installer[`fechaVencimientoCertificadoMedico`];
          } else if (document.lenguaje === "DC3") {
            isRequired = requiredDocuments.includes("DC3");
            fileExtension = installer[`extensionDc3`];
            dateFile = installer[`fechaVencimientoDc3`];
          } else if (document.lenguaje === "CREDENTIAL") {
            isRequired = requiredDocuments.includes("CREDENCIAL");
            fileExtension = installer[`extensionCredencial`];
          } else if (document.lenguaje === "OTHER") {
            isRequired = requiredDocuments.includes("OTRO");
            fileExtension = installer[`extensionOtro`];
          }
          const hasFile =
            fileData.url && ["image", "pdf"].includes(fileData.extension);

          documentClass = hasFile ? "document-white" : "document-gray";

          let borderClass = "border-red"; // default si no hay fecha

          if (dateFile) {
            const fileDate = new Date(dateFile);
            const today = new Date();
            const twoMonthsLater = new Date();
            twoMonthsLater.setDate(today.getDate() + 60);

            if (fileDate < today) {
              borderClass = "border-red";
            } else if (fileDate <= twoMonthsLater) {
              borderClass = "border-yellow";
            } else {
              borderClass = "border-green";
            }
          }

          const getStatusIcon = () => {
            if (!hasFile) return No;
            if (["CREDENTIAL", "PHOTO"].includes(document.lenguaje))
              return CheckIcon;
            if (!dateFile) return Expirado;
            const fileDate = new Date(dateFile);
            if (fileDate < today) return Expirado;
            if (fileDate <= twoMonthsLater) return AExpirarIcon;
            return CheckIcon;
          };

          // const PDFPreview = React.memo(({ pdfUrl }) => (
          //   <div
          //     className="pdf-container"
          //     onClick={() => openPreviewModal(pdfUrl, "pdf")}
          //     style={{ width: "101px", height: "115px", overflow: "hidden" }}
          //   >
          //     <Document file={pdfUrl}>
          //       <Page pageNumber={1} width={101} />
          //     </Document>
          //   </div>
          // ));

          return (
            <div
              key={index}
              className={`document-box document-white ${
                document.lenguaje === "PHOTO" ? "height-162" : ""
              }`}
            >
              <div className="document-box-status">
                <img src={hasFile ? getStatusIcon() : No} alt="" />
              </div>
              <div className="document-box-name">
                {document.lenguaje === "PHOTO" && (
                  <h3 className="document-title">{document.descripcion}</h3>
                )}
                {/* <div className="document-preview">
                  {fileData.extension === "pdf" || fileExtension === "pdf" ? (
                    <PDFPreview
                      key={`${document.lenguaje}-${renderKey}`}
                      pdfUrl={fileUrl}
                    />
                  ) : (
                    <img
                      src={fileUrl}
                      alt={document.descripcion}
                      className={`document-image ${
                        fileUrl === fileData.url ? "clickable" : "not-clickable"
                      }`}
                      onClick={() => {
                        if (fileData.url) {
                          openPreviewModal(
                            fileUrl,
                            fileData.extension?.toLowerCase()
                          );
                        }
                      }}
                      onError={(e) => (e.target.src = ActivarIcon)}
                    />
                  )}
                </div> */}
                <div className="document-preview">
                  {document.lenguaje === "PHOTO" ? (
                    hasFile ? (
                      <div
                        className="photo-wrapper"
                        style={{
                          position: "relative",
                          display: "inline-block",
                        }}
                      >
                        <img
                          src={fileUrl}
                          alt={document.descripcion}
                          className="document-image clickable"
                          onClick={() =>
                            openPreviewModal(fileUrl, fileData.extension)
                          }
                          onKeyDown={(e) =>
                            (e.key === "Enter" || e.key === " ") &&
                            openPreviewModal(fileUrl, fileData.extension)
                          }
                          tabIndex={0}
                        />
                        {puedeModificarDocumentos(user) && (
                          <PhotoWhiteBgGate
                            onPass={(validatedFile) => {
                              setPendingByType((prev) => ({
                                ...prev,
                                [document.lenguaje]: validatedFile,
                              }));
                            }}
                            onFail={(err) => {
                              confirmDialog({
                                html: err.message || String(err),
                                icon: "warning",
                                iconHtml: `<img src="${Usuarios}" width="50" height="50" />`,
                                confirmButtonText: "OK",
                                mostrarCancelar: false,
                              });
                            }}
                          >
                            {({ openPicker, busy }) => (
                              <button
                                type="button"
                                className="photo-change-btn"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  openPicker();
                                }}
                                disabled={busy}
                                title="Cambiar foto"
                                aria-label="Cambiar foto"
                                style={{
                                  position: "absolute",
                                  marginLeft: 10,
                                  bottom: 8,
                                  padding: "6px 10px",
                                  fontSize: 12,
                                  borderRadius: 12,
                                  border: "1px solid #C3C3C3",
                                  background: "#FFFFFF",
                                  cursor: "pointer",
                                  boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                                }}
                              >
                                Cambiar
                              </button>
                            )}
                          </PhotoWhiteBgGate>
                        )}
                      </div>
                    ) : (
                      <PhotoWhiteBgGate
                        onPass={(validatedFile) => {
                          setPendingByType((prev) => ({
                            ...prev,
                            [document.lenguaje]: validatedFile,
                          }));
                        }}
                        onFail={(err) => {
                          confirmDialog({
                            html: err.message || String(err),
                            icon: "warning",
                            iconHtml: `<img src="${Usuarios}" width="50" height="50" />`,
                            confirmButtonText: "OK",
                            mostrarCancelar: false,
                          });
                        }}
                        bgOptions={{
                          // puedes ajustar “perillas” aquí si quieres distinto a los defaults
                          minWhitePct: 0.7,
                          skipRadius: 3,
                          borderCropPx: 12,
                        }}
                      >
                        {({ openPicker, busy }) => (
                          <div
                            className="photo-drop clickable"
                            onClick={() =>
                              puedeModificarDocumentos(user) && openPicker()
                            }
                            tabIndex={0}
                            style={{
                              width: 101,
                              height: 115,
                              border: "1px dashed #C3C3C3",
                              borderRadius: 12,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontFamily: "Nunito",
                              fontSize: 12,
                              color: "#223D51",
                              backgroundColor: "#F8F8F8",
                              opacity: busy ? 0.6 : 1,
                              pointerEvents: busy ? "none" : "auto",
                            }}
                          >
                            <span>{busy ? "Analizando..." : "Subir foto"}</span>
                          </div>
                        )}
                      </PhotoWhiteBgGate>
                    )
                  ) : (
                    <DocumentQualityGate
                      onPass={(validatedFile) => {
                        handleFileUpload(
                          { target: { files: [validatedFile] } },
                          document.name,
                        );
                      }}
                      onFail={(err) => {
                        confirmDialog({
                          html: err.message || String(err),
                          icon: "warning",
                          iconHtml: `<img src="${Usuarios}" width="50" height="50" />`,
                          confirmButtonText: "OK",
                          mostrarCancelar: false,
                        });
                      }}
                      accept={
                        DOC_GATE_BY_TYPE[document.lenguaje]?.accept ||
                        ".jpg,.jpeg,.png,.pdf"
                      }
                      pdfPolicy={
                        DOC_GATE_BY_TYPE[document.lenguaje]?.pdfPolicy ||
                        "allow"
                      }
                      docOptions={
                        DOC_GATE_BY_TYPE[document.lenguaje]?.docOptions
                      }
                    >
                      {({ openPicker, busy }) => (
                        <div
                          className="doc-preview-box clickable"
                          onClick={() => {
                            if (fileUrl !== Placeholder && fileData?.url) {
                              openPreviewModal(
                                fileData.blob || fileData.url,
                                fileData.extension,
                              );
                            } else if (
                              puedeModificarDocumentos(user) &&
                              !busy
                            ) {
                              openPicker();
                            }
                          }}
                          style={{
                            width: "125px",
                            height: "27px",
                            border: "1px solid #C3C3C3",
                            borderRadius: "13.5px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: "0 10px",
                            fontFamily: "Nunito",
                            fontSize: "12px",
                            color: "#223D51",
                            backgroundColor: "#F1F1F1",
                            cursor: busy ? "progress" : "pointer",
                            opacity: busy ? 0.7 : 1,
                          }}
                          title={
                            busy
                              ? "Analizando..."
                              : fileUrl !== Placeholder
                                ? "Ver"
                                : "Subir"
                          }
                          aria-busy={busy ? "true" : "false"}
                        >
                          <span
                            style={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              maxWidth: "90px",
                            }}
                          >
                            {["DC3", "IMSS", "INE", "SUA"].includes(
                              document.name,
                            )
                              ? document.name
                              : document.name.charAt(0).toUpperCase() +
                                document.name.slice(1).toLowerCase()}
                          </span>
                          <img
                            src={fileUrl !== Placeholder ? Visible : SelectFile}
                            alt="icono"
                            style={{
                              width: fileUrl !== Placeholder ? "16px" : "10px",
                              height: "16px",
                            }}
                          />
                        </div>
                      )}
                    </DocumentQualityGate>
                  )}
                  <Tooltip
                    text={
                      {
                        INE: "Cuida que tu documento sea legible y no este recortado en los bordes.",
                        IMSS: "Cuida que tu documento sea legible y no este recortado en los bordes.",
                        DC3: "Cuida que tu documento sea legible y no este recortado en los bordes.",
                        MEDICAL_CERTIFICATE:
                          "Cuida que tu documento sea legible y no este recortado en los bordes.",
                        CREDENTIAL:
                          "Cuida que tu documento sea legible y no este recortado en los bordes.",
                        PHOTO:
                          "Cuida que tu foto sea legible, mantener una expresión no tan sonriente y que tenga un fondo blanco uniforme.",
                        OTHER: "Documento adicional solicitado.",
                      }[document.lenguaje] || "Especificaciones no definidas."
                    }
                  />
                </div>
              </div>

              {[
                "INE",
                "IMSS",
                "MEDICAL_CERTIFICATE",
                "DC3",
                "CREDENTIAL",
                "PHOTO",
                "OTHER",
              ].includes(document.lenguaje) && (
                <>
                  <div className="document-box-date-plus">
                    {["PHOTO", "CREDENTIAL"].includes(document.lenguaje) ? (
                      <p>-</p>
                    ) : !fileData.url && !dateFile ? (
                      <p>-</p>
                    ) : (
                      <div className="d-flex justify-content-end align-items-center">
                        <DatePicker
                          selected={
                            documentDates[document.lenguaje] ??
                            (dateFile ? parseDateFromBackend(dateFile) : null)
                          }
                          onChange={(date) =>
                            puedeModificarDocumentos(user)
                              ? setDocumentDates((prev) => ({
                                  ...prev,
                                  [document.lenguaje]: date,
                                }))
                              : null
                          }
                          readOnly={!puedeModificarDocumentos(user)}
                          disabled={!puedeModificarDocumentos(user)}
                          placeholderText="falta fecha"
                          className={`document-date-picker-plus ${borderClass}`}
                          dateFormat="dd/MM/yyyy"
                        />

                        <img
                          src={EditarIcon}
                          alt="Guardar"
                          onClick={() =>
                            puedeModificarDocumentos(user) &&
                            updateDate(
                              documentDates[document.lenguaje],
                              document.lenguaje,
                            )
                          }
                          className="document-date-icon"
                          style={{
                            opacity: puedeModificarDocumentos(user) ? 1 : 0.5,
                            pointerEvents: puedeModificarDocumentos(user)
                              ? "auto"
                              : "none",
                          }}
                        />
                      </div>
                    )}
                  </div>

                  <div className="document-box-button">
                    {/* <button
                      className={`upload-button ${
                        puedeModificarDocumentos(user)
                          ? "clickable"
                          : "not-clickable"
                      }`}
                      onClick={() => {
                        if (puedeModificarDocumentos(user)) {
                          handleButtonClick(document.name);
                        }
                      }}
                      disabled={!puedeModificarDocumentos(user)}
                    >
                      <img
                        className="upload-button-icon clickeable"
                        alt="Subir archivo"
                        src={Subir}
                        style={{
                          opacity: puedeModificarDocumentos(user) ? 1 : 0.5,
                          pointerEvents: puedeModificarDocumentos(user)
                            ? "auto"
                            : "none",
                        }}
                      />
                    </button> */}

                    <input
                      type="file"
                      ref={(el) => (fileInputRefs.current[document.name] = el)}
                      style={{ display: "none" }}
                      //accept=".jpg,.jpeg,.png,.pdf"
                      accept={
                        document.lenguaje === "PHOTO"
                          ? ".jpg,.jpeg,.png"
                          : ".jpg,.jpeg,.png,.pdf"
                      }
                      onChange={(event) =>
                        handleFileUpload(event, document.name)
                      }
                    />
                    <CustomButton
                      onClick={() => {
                        const file = pendingByType[document.lenguaje];
                        if (!file) return;

                        const fakeEvent = { target: { files: [file] } };
                        const afterUploadDate =
                          documentDates[document.lenguaje] || null;

                        handleFileUpload(fakeEvent, document.name, {
                          afterUploadDate,
                        }).then(() => {
                          setPendingByType((prev) => {
                            const { [document.lenguaje]: _, ...rest } = prev;
                            return rest;
                          });
                        });
                      }}
                      disabled={!pendingByType[document.lenguaje]}
                      text={hasFile ? "Cargar nuevo" : "Añadir"}
                      background={hasFile ? "#223D51" : "#62C776"} // puedes ajustar los colores
                      width="126px"
                      height="31px"
                      fontSize="14px"
                      color="#FFFFFF"
                      fontWeight={700}
                      border={0}
                      icon={hasFile} // ← solo muestra el icono si hay archivo
                      src={hasFile ? Subir : undefined}
                      iconW="12px"
                      iconM="5px"
                      hoverShadow="0 0 6px rgba(0,0,0,0.15)"
                    />
                  </div>
                  <div
                    className="document-box-button menu-wrapper"
                    data-menu-key={`${document.lenguaje}-${index}`}
                  >
                    <button
                      type="button"
                      className="kebab-button"
                      title="Más opciones"
                      disabled={!hasFile} // 👈 deshabilitado si no hay doc
                      onClick={() => {
                        if (!hasFile) return;
                        setOpenMenuId(
                          openMenuId === `${document.lenguaje}-${index}`
                            ? null
                            : `${document.lenguaje}-${index}`,
                        );
                      }}
                    >
                      <img
                        src={MenuIcon}
                        alt="Menú de opciones"
                        className="menu-icon"
                        style={{ width: "18px", height: "18px" }}
                      />
                    </button>

                    {/* El popover solo aparece si hay archivo y coincide el id abierto */}
                    {hasFile &&
                      openMenuId === `${document.lenguaje}-${index}` && (
                        <div className="kebab-menu">
                          <button
                            className="kebab-item"
                            onClick={() => {
                              const ext =
                                fileData.extension === "pdf" ? "pdf" : "jpg";
                              downloadFile(
                                fileUrl,
                                `${document.lenguaje}.${ext}`,
                              );
                              setOpenMenuId(null);
                            }}
                          >
                            <img
                              src={DescargaAzul}
                              alt=""
                              className="kebab-icon"
                            />
                            Descargar
                          </button>

                          <button
                            className="kebab-item"
                            onClick={async () => {
                              if (!puedeModificarDocumentos(user)) return;
                              await deleteInstallerDocument(
                                API_URL,
                                id,
                                document.name,
                              );
                              await fetchData();
                              setOpenMenuId(null);
                            }}
                            disabled={!puedeModificarDocumentos(user)}
                            title={
                              puedeModificarDocumentos(user)
                                ? "Eliminar"
                                : "No tienes permiso"
                            }
                          >
                            <img src={Eliminar} alt="" className="kebab-icon" />
                            Eliminar
                          </button>
                        </div>
                      )}
                  </div>
                </>
              )}
            </div>
          );
        })}
      </div>
    </>
  );

  return (
    <div
      className="docsInstal-layout"
      style={{ display: "flex", height: "100%" }}
    >
      {isLoading ? null : (
        <div className="docsInstal-sidebar" style={{ width: "12rem" }}>
          <SideMenu items={itemsProviders} />
        </div>
      )}
      <div key={renderKey} className="docsInstal-main main-container">
        <div className="content-container">
          {isLoading ? (
            <div className="spinner d-flex justify-content-center">
              <Oval
                visible={true}
                height="80"
                width="80"
                color="#4fa94d"
                ariaLabel="oval-loading"
                wrapperStyle={{}}
                wrapperClass=""
              />
            </div>
          ) : (
            documentsInstaller()
          )}
        </div>
      </div>

      {showModal && (
        <div className="preview-modal" onClick={closeModal}>
          <div className="preview-content" onClick={(e) => e.stopPropagation()}>
            <div>
              <a
                href={modalContent.url}
                download
                className="download-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  className="upload-button-icon-plus"
                  alt="descargar archivo"
                  src={DescargaAzul}
                />
              </a>{" "}
            </div>
            {modalContent.extension === "pdf" && modalContent.url ? (
              <Document
                file={modalContent.url} // ✅ Usa directamente la URL
                onLoadSuccess={({ numPages }) => setNumPages(numPages)}
                loading={<Oval height={40} width={40} color="#4fa94d" />}
                error={<p style={{ color: "red" }}>No se pudo cargar el PDF</p>}
              >
                <Page pageNumber={1} />
              </Document>
            ) : (
              <img
                src={modalContent.url}
                alt="Vista previa"
                style={{ maxWidth: "90%" }}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default DocumentsInstaller;
